import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center pt-[4px] pb-[4px]" data-id="element-0" data-mp="31c9ygdv1bhw7">
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed font-[800]" data-id="element-1" data-mp="2wj8g1vvmd07v">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen bg-brand-surface font-sans text-brand-text selection:bg-brand-purple/25 selection:text-brand-purpleDark" data-id="element-2" data-mp="23utby4e102bb">
      <div className="pointer-events-none fixed inset-0 -z-10 reiki-pattern opacity-[0.025]" aria-hidden="true" data-id="element-3" data-mp="3mlj8gtrwtb2j" />
      <UrgencyBanner data-id="element-4" data-mp="3rcj2nr9n9f1c" />
      <Hero data-id="element-5" data-mp="3rdaq2et386gj" />
      <PackContents data-id="element-6" data-mp="3rdkl4gszp3t3" />
      <InitialTestimonials data-id="element-7" data-mp="3recf5n6xuth9" />
      <PainPoints data-id="element-8" data-mp="5ot150vj28n" />
      <MethodOverview data-id="element-9" data-mp="67yhm9c7y5s" />
      <MoreTestimonials data-id="element-10" data-mp="4n725ibkvc5" />
      <Guarantee data-id="element-11" data-mp="82k72sfnuax" />
      <FAQ data-id="element-12" data-mp="2zl3bdjx5744s" />
      <CostComparison data-id="element-13" data-mp="2zld4hgdhhrep" />
      <TransitionPhrase data-id="element-14" data-mp="2zm4zaoz9bl3x" />
      <EmotionalClose data-id="element-15" data-mp="2zmwif0bo3qdb" />
      <Footer data-id="element-16" data-mp="2zng2onosiqui" />
      <FloatingNotification data-id="element-17" data-mp="33mf25srr5vek" />
    </div>;
}